import { Button, Meta, theme } from 'aimo-ui';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { StyledWrapper } from 'styles/ContainerStyles';
import IllustrationContainer from './IllustrationContainer';

const ProgressBar: React.FC<{ progress: number }> = ({ progress }) => (
  <View style={styles.progressBarContainer}>
    <View
      style={[
        styles.progressFill,
        { width: `${Math.min(100, Math.max(0, progress))}%` },
      ]}
    />
  </View>
);

interface ButtonConfig {
  text: string;
  disabled?: boolean;
  loading?: boolean;
  icon?: React.ComponentType;
  testID?: string;
  onPress?: () => void;
}
interface StepWrapperProps {
  progress?: number;
  description?: string;
  illustration?: React.ReactNode;
  illustrationPadding?: number;
  children?: React.ReactNode;
  errorMessage?: string;
  testID?: string;
  primaryButton?: ButtonConfig;
  secondaryButton?: ButtonConfig;
}

export const StepWrapper: React.FC<StepWrapperProps> = ({
  progress,
  description,
  illustration,
  illustrationPadding,
  children,
  errorMessage,
  testID,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <StyledWrapper mt={0} mb={0} testID={testID}>
      <StyledWrapper mt={10} mb={0}>
        {progress && <ProgressBar progress={progress} />}
      </StyledWrapper>

      {description && (
        <StyledWrapper mb={30}>
          <Meta color={theme.colors.black}>{description}</Meta>
        </StyledWrapper>
      )}

      {children}

      {illustration && (
        <IllustrationContainer padding={illustrationPadding}>
          {illustration}
        </IllustrationContainer>
      )}

      {errorMessage && (
        <StyledWrapper mb={10}>
          <Meta color={theme.colors.aimoUiRed}>{errorMessage}</Meta>
        </StyledWrapper>
      )}

      {primaryButton && (
        <StyledWrapper mb={0}>
          <Button
            testID={primaryButton.testID}
            size="l"
            text={primaryButton.text}
            onPress={primaryButton.onPress}
            iconComponent={primaryButton.icon}
            iconRight={!!primaryButton.icon}
            disabled={primaryButton.disabled}
            loading={primaryButton.loading}
          />
        </StyledWrapper>
      )}
      {secondaryButton && (
        <StyledWrapper mb={0} mt={10}>
          <Button
            testID={secondaryButton.testID}
            size="l"
            buttonType="tertiary"
            text={secondaryButton.text}
            onPress={secondaryButton.onPress}
            iconComponent={secondaryButton.icon}
            iconRight={!!secondaryButton.icon}
            disabled={secondaryButton.disabled}
            loading={secondaryButton.loading}
          />
        </StyledWrapper>
      )}
    </StyledWrapper>
  );
};

const styles = StyleSheet.create({
  progressBarContainer: {
    height: 4,
    backgroundColor: theme.colors.gray100,
    borderRadius: 2,
    marginBottom: 30,
  },
  progressFill: {
    height: '100%',
    backgroundColor: theme.colors.boost.green,
    borderRadius: 2,
  },
});

export default StepWrapper;
